import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { useNavigate } from 'react-router-dom';

const AddProductsCompleted = ({ values, isSubmitting }: FormikProps<any>) => {
  const navigate = useNavigate();
  return (
    <Stack p={5}>
      <Typography variant="h4" gutterBottom>
        Success
      </Typography>
      <Alert severity="success" title="Adding Products">
        <Typography>
          Adding {values.products ? values.products.length : ''} Products
        </Typography>
        <Typography variant="body2">
          The system is now matching the product information with existing
          records. This may take a few minutes. Please check your catalog later
          to view the updated products.
        </Typography>
      </Alert>
      <Box alignSelf="flex-end">
        <Button
          variant="flat"
          onClick={() => navigate('../..', { relative: 'path' })}
        >
          Finish
        </Button>
      </Box>
    </Stack>
  );
};

export default AddProductsCompleted;
